
import Pagination from '../../Pagination';
import Post from '../../Post';
import Spacing from '../../Spacing';
import imageUrlBuilder from '@sanity/image-url';
import client from '../../../sanityClient'

const builder = imageUrlBuilder(client);
const urlFor = (src) => builder.image(src);

// export default function BlogSectionStyle2({ currentPage, totalPages, setCurrentPage }) {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     const getData = async () => {
//       const news = await fetchLatestNews();
//       setData(news);
//     };
//     getData();
//   }, []);

//   return (
//     <div className="container">
//       <div className="row cs_row_gap_50">
//         {data?.map((item, index) => (
//           <div className="col-xl-4 col-md-6" key={index}>
//             <Post
//               title={item.title}
//               thumbUrl={
//                 item.coverImage?.asset?.url
//                   ? urlFor(item.coverImage).width(600).url()
//                   : '/images/default-cover.jpg'
//               }
//               alt={item.coverImage?.alt || item.title}
//               date={new Date(item.publishedAt).toLocaleDateString()}
//               btnText="Read More"
//               href={`/news/${item.slug}`}
//               socialShare={false}
//             />
//           </div>
//         ))}
//       </div>
//       <Spacing md="110" lg="70" />
//       <Pagination
//         currentPage={currentPage}
//         totalPages={totalPages}
//         setCurrentPage={setCurrentPage}
//       />
//     </div>
//   );
// }

export default function BlogSectionStyle2({ data, currentPage, totalPages, setCurrentPage }) {
  // You might remove fetch inside here (you currently fetch via fetchLatestNews)
  // Instead rely on the `data` prop passed in.

  return (
    <div className="container">
      <div className="row cs_row_gap_50">
        {data?.map((item, index) => (
          <div className="col-xl-4 col-md-6" key={index}>
            <Post
              title={item.title}
              thumbUrl={
                item.coverImage?.asset?.url
                  ? urlFor(item.coverImage).width(600).url()
                  : '/images/default-cover.jpg'
              }
              alt={item.coverImage?.alt || item.title}
              date={new Date(item.publishedAt).toLocaleDateString()}
              btnText="Read More"
              href={`/news/${item.slug.current || item.slug}`}
              socialShare={false}
            />
          </div>
        ))}
      </div>
      <Spacing md="110" lg="70" />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}
